// Labels are maintained in Locize: latest / global / PDP_GUIDANCE_*.
// Use the translator's active locale, including the shop-specific fallback chain.
export default function copy(t, key, values = {}) {
  const text = t(`PDP_GUIDANCE_${key.toUpperCase()}`)
  return Object.keys(values).reduce(
    (result, name) => result.split(`{${name}}`).join(String(values[name])),
    text,
  )
}
